import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Patient } from '../../../core/models/patient/patient';
import { MatDialog } from '@angular/material/dialog';
import { PreviewDocumentComponent } from '../../../shared/components/preview-document/preview-document.component';
import { GetValueForCodePipe } from '../../../shared/pipes/get-value-for-code.pipe';
import { PreviewImagesComponent } from '../../../shared/components/preview-images/preview-images.component';

@Component({
  selector: 'app-physician-patient-sidebar',
  templateUrl: './physician-patient-sidebar.component.html',
  styleUrls: ['./physician-patient-sidebar.component.scss']
})
export class PhysicianPatientSidebarComponent implements OnInit {
  @Input() sectionName: string;
  @Input() patientProfile: Patient;
  @Output() toggleEvent = new EventEmitter();

  showHideSelected = false;

  constructor(
    public dialog: MatDialog,
    private codePipe: GetValueForCodePipe) { }

  ngOnInit() {
  }

  ngOnDestroy() {

  }
  cancel() {
    this.showHideSelected = true;
    this.toggleEvent.emit(this.patientProfile);
  }

  togglePopUp(patdata: Patient) {
    this.patientProfile = patdata;
    this.toggleEvent.emit(this.patientProfile);
  }
  previewDocument(title: string, location: string, code: string) {
    if (title && code)
      title = this.codePipe.transform(title, code);

    const dialogRef = location.endsWith('pdf') ? this.dialog.open(PreviewDocumentComponent, {
      maxWidth: '80%',
      panelClass: 'preview-modal',
      disableClose: true,
      backdropClass: 'preview-modal',
      data: { documentTitle: title, documentLocation: location }
    })
      : this.dialog.open(PreviewImagesComponent, {
        width: '80%',
        disableClose: true,
        data: {
          documentTitle: title, images: [{ location: location, text: title }]
        }
      });
  }
}
